/**
 * @generated SignedSource<<b23dd41b7bb86777bc0174f0ac0ae6b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildApprovalReviewers_approveMutation$variables = {
  buildLocator: string;
};
export type BuildApprovalReviewers_approveMutation$data = {
  readonly approveQueuedBuild: {
    readonly status: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"BuildApprovalControls_approvalInfo" | "BuildApprovalDetailsPopupContent_approvalInfo" | "BuildApprovalDetailsPopup_anchor" | "BuildApprovalReviewers_approvalInfo" | "BuildApprovalReviewers_canViewApprovalInfo">;
  } | null | undefined;
};
export type BuildApprovalReviewers_approveMutation = {
  response: BuildApprovalReviewers_approveMutation$data;
  variables: BuildApprovalReviewers_approveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "username",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rawId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserAvatars",
    "kind": "LinkedField",
    "name": "avatars",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize20",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize28",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize32",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize40",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize56",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize64",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlToSize80",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildApprovalReviewers_approveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApprovalInfo",
        "kind": "LinkedField",
        "name": "approveQueuedBuild",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildApprovalReviewers_canViewApprovalInfo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildApprovalReviewers_approvalInfo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildApprovalControls_approvalInfo"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildApprovalDetailsPopup_anchor"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuildApprovalDetailsPopupContent_approvalInfo"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildApprovalReviewers_approveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApprovalInfo",
        "kind": "LinkedField",
        "name": "approveQueuedBuild",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configurationValid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserApprovals",
            "kind": "LinkedField",
            "name": "userApprovals",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserApprovalRule",
                "kind": "LinkedField",
                "name": "userApproval",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "approved",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupApprovals",
            "kind": "LinkedField",
            "name": "groupApprovals",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GroupApprovalRule",
                "kind": "LinkedField",
                "name": "groupApproval",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredApprovalsCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Users",
                    "kind": "LinkedField",
                    "name": "currentlyApprovedBy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": true,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canBeApprovedByCurrentUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeoutTimestamp",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4265b8fa4c45c66b3498291e015684ce",
    "id": null,
    "metadata": {},
    "name": "BuildApprovalReviewers_approveMutation",
    "operationKind": "mutation",
    "text": "mutation BuildApprovalReviewers_approveMutation(\n  $buildLocator: String!\n) {\n  approveQueuedBuild(buildLocator: $buildLocator) {\n    status\n    ...BuildApprovalReviewers_canViewApprovalInfo\n    ...BuildApprovalReviewers_approvalInfo\n    ...BuildApprovalControls_approvalInfo\n    ...BuildApprovalDetailsPopup_anchor\n    ...BuildApprovalDetailsPopupContent_approvalInfo\n  }\n}\n\nfragment AvatarFragment on User {\n  rawId\n  name\n  username\n  avatars {\n    urlToSize20\n    urlToSize28\n    urlToSize32\n    urlToSize40\n    urlToSize56\n    urlToSize64\n    urlToSize80\n  }\n}\n\nfragment BuildApprovalControls_approvalInfo on ApprovalInfo {\n  canBeApprovedByCurrentUser\n  status\n  timeoutTimestamp\n}\n\nfragment BuildApprovalDetailsPopupContent_approvalInfo on ApprovalInfo {\n  canBeApprovedByCurrentUser\n  ...BuildApprovalReviewers_approvalInfo\n}\n\nfragment BuildApprovalDetailsPopup_anchor on ApprovalInfo {\n  status\n}\n\nfragment BuildApprovalReviewers_approvalGroups on GroupApprovals {\n  groupApproval {\n    group {\n      key\n    }\n    ...BuildApprovalReviewers_groupApproval\n  }\n}\n\nfragment BuildApprovalReviewers_approvalInfo on ApprovalInfo {\n  userApprovals {\n    ...BuildApprovalReviewers_groupedByStatusApprovals\n  }\n  groupApprovals {\n    ...BuildApprovalReviewers_approvalGroups\n  }\n}\n\nfragment BuildApprovalReviewers_approvalUser on User {\n  name\n  username\n  rawId\n  ...AvatarFragment\n}\n\nfragment BuildApprovalReviewers_canViewApprovalInfo on ApprovalInfo {\n  configurationValid\n  userApprovals {\n    count\n  }\n  groupApprovals {\n    count\n  }\n}\n\nfragment BuildApprovalReviewers_groupApproval on GroupApprovalRule {\n  group {\n    name\n  }\n  requiredApprovalsCount\n  currentlyApprovedBy {\n    user {\n      id\n      ...BuildApprovalReviewers_approvalUser\n    }\n  }\n}\n\nfragment BuildApprovalReviewers_groupedByStatusApprovals on UserApprovals {\n  userApproval {\n    approved\n    user {\n      id\n      ...BuildApprovalReviewers_approvalUser\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a7301994d7398c837593a4159d3f6d54";

export default node;
